// extracted by mini-css-extract-plugin
module.exports = {"box":"privacy_box__u6cu-","attention":"privacy_attention__2R8TX"};